import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Barrage from '@/views/special/Barrage'
import InviteFriends from '@/views/special/InviteFriends'
Vue.use(Router)
export default new Router({
  routes: [{
    path:'/',
    component: Index,
    children: [{
      path: '',
      redirect: 'inviteFriends'
    },{
      path: '/barrage',
      name: 'Barrage',
      component: Barrage
    },{
      path: '/inviteFriends',
      name: 'InviteFriends',
      component: InviteFriends
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js